<app-conditional-content-by-page-category
  *ngIf="pageCategory$ | async as pageCategory"
  [pageCategory]="pageCategory"
></app-conditional-content-by-page-category>
